import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { SITE } from "@/data/content";
import { WhatsAppIcon } from "./WhatsAppIcon";

export default function FloatingCTAs() {
  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col gap-3 items-end" style={{ bottom: "max(1.25rem, env(safe-area-inset-bottom))" }}>
      <a
        href={SITE.whatsapp}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        data-testid="floating-whatsapp-button"
        className="relative w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-deep hover:scale-110 transition-transform duration-300"
      >
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-pulse-ring" />
        <WhatsAppIcon className="w-7 h-7 relative" />
      </a>
      <a
        href={SITE.phoneHref}
        aria-label={`Call ${SITE.phoneDisplay}`}
        data-testid="floating-call-button"
        className="md:hidden w-14 h-14 rounded-full bg-navy text-gold border border-gold/50 flex items-center justify-center shadow-deep hover:scale-110 transition-transform duration-300"
      >
        <Phone className="w-6 h-6" />
      </a>
      <motion.p
        className="hidden md:block font-mono text-[10px] uppercase tracking-[0.2em] text-navy/50 bg-white/80 backdrop-blur px-3 py-1.5 rounded-full border border-gold/30"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 2 }}
      >
        Talk to us · {SITE.phoneDisplay}
      </motion.p>
    </div>
  );
}
